import { ActionType } from "UI/UI.Controls/Actions/IAction";
import { ILogicalComponent } from "UI/UI/LogicalTree/ILogicalComponent";
import { StandardAction } from "./Actions/StandardAction";
import { ListFrameRightsEvaluationOverrides } from "./Frames/ListFrameRightsEvaluationOverrides";
import { ObjectListEdit } from "./ObjectListEdit";

export class ObjectListEditRightsEvaluationOverrides extends ListFrameRightsEvaluationOverrides {
    protected override readonly __frame: ObjectListEdit;

    protected override get _frame(): ObjectListEdit {
        return this.__frame;
    }

    protected override _initializeOverrides(): void {
        super._initializeOverrides();
    }
    protected override async _standardActionsEnabled(controlWrapper: ILogicalComponent): Promise<boolean | null> {
        const standardAction = controlWrapper.control as StandardAction;
        switch (standardAction.actionType) {
            case ActionType.standardNewRecord:
            case ActionType.standardDeleteRecord:
            case ActionType.standardCopyRecord:
                return !!this._frame.isEditing;
        }
        return await super._standardActionsEnabled(controlWrapper);
    }
    protected override async _standardActionsVisible(controlWrapper: ILogicalComponent): Promise<boolean | null> {
        const standardAction = controlWrapper.control as StandardAction;
        switch (standardAction.actionType) {
            case ActionType.standardNewRecord:
            case ActionType.standardDeleteRecord:
            case ActionType.standardCopyRecord:
                return true;
        }
        return await super._standardActionsVisible(controlWrapper);
    }
}
